import React, {ReactElement} from "react";
import {ButtonBase, Typography} from "@mui/material";
import {PD_SM} from "../../shared/dimens";
import {mediumGray} from "../../shared/colors";
import {Shape, SHAPES_METADATA} from "./model/shapes/types";

function ShapeButton({shape, onAdd}: {
  shape: Shape,
  onAdd: (kind: Shape) => void,
}): ReactElement {
  return (
    <ButtonBase
      onClick={() => onAdd(shape)}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
        padding: PD_SM,
        borderRadius: 8,
        border: "2px solid transparent",
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLButtonElement).style.borderColor = "#000066";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLButtonElement).style.borderColor = "transparent";
      }}>
      <div style={{width: "100%", aspectRatio: 1}}>
        <img src={SHAPES_METADATA.findMetadata(shape).url} style={{width: "100%", height: "100%"}}/>
      </div>
    </ButtonBase>
  );
}

export function ShapesPanel(props: {
  onShapeAdd: (shape: Shape) => void;
}): ReactElement {
  return (
    <div style={{display: "flex", flexDirection: "column", gap: PD_SM, overflow: "scroll"}}>
      <Typography variant={"caption"} style={{color: mediumGray, textAlign: "center"}}>
        Click a shape to add it to your canvas
      </Typography>
      <div style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gap: PD_SM,
      }}>
        {Object.values(Shape).map(shape => (
          <ShapeButton key={shape} shape={shape} onAdd={props.onShapeAdd}/>
        ))}
      </div>
    </div>
  );
}
